'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function Switch(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M734.56 576.032a29.344 29.344 0 0 1 17.44 4.736c7.68 4.928 12.832 12.896 14.944 21.728a38.56 38.56 0 0 1-3.2 26.88l-96 120.832c-8.864 17.024-28.448 22.848-43.744 13.024s-20.544-31.584-11.712-48.608l54.4-68.48H291.104a35.072 35.072 0 1 1 0-70.144h441.856l1.632 0.032zM289.44 448a29.344 29.344 0 0 1-17.44-4.736 35.264 35.264 0 0 1-14.944-21.728 38.56 38.56 0 0 1 3.2-26.88l96.032-120.832c8.832-17.024 28.416-22.848 43.712-13.024 15.296 9.824 20.544 31.584 11.712 48.608l-54.4 68.48h375.616a35.072 35.072 0 1 1 0 70.144H291.072l-1.6-0.032zM64 127.68C64 92.512 92.8 64 127.712 64H896.32C931.488 64 960 92.8 960 127.712V896.32c0 35.2-28.8 63.712-63.712 63.712H127.68C92.512 960 64 931.2 64 896.288V127.68z m64 32.32v703.936A32 32 0 0 0 160 896h704a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32H160a32 32 0 0 0-32 32z' })
  );
}
Switch.displayName = 'Switch';

module.exports = Switch;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/switch.js
// module id = 217
// module chunks = 0